import { Dispatch, SetStateAction } from 'react'
import { Field } from '@templates/AddNewItemModal/Content'
import { FilterItem, FilterState } from '@hooks/useItemsFilters'
import { Option } from '@organisms/Select'
import { SelectSearchFieldParams } from '@templates/AddNewItemModal/templates/selectSearchField'

export enum RiskMapDangersFieldNames {
  WORK_PLACE = 'workPlace',
  OBJECT = 'object',
  KIND = 'kind',
  HAZARD = 'hazard',
  EVENT = 'event',
}

export type StateType = {
  relations?: Partial<Record<RiskMapDangersFieldNames, FilterItem>>
} & Record<string, FilterItem>

export type ReturnType<T = FilterState> = {
  field: (fieldParams?: Partial<SelectSearchFieldParams>) => Field
  setFilters: Dispatch<SetStateAction<T>>
}

export type UseDangerField = (options: {
  params: Partial<SelectSearchFieldParams>
  onOneItem?: (value: Option) => void
  skip?: boolean
  initFilters?: StateType
}) => ReturnType<StateType | undefined>
